import _ from 'lodash';
import { createActionFactory } from '../../common/redux';
const { createAction, createApiFailureAction } = createActionFactory('Common Entities => channel => ');

const add = createAction('add channels', (channels) => (_.isArray(channels) ? { channels } : { channels: [channels] }));

const fetch = createAction('fetch channels');
const fetchFailure = createApiFailureAction('fetch channels failure');
const fetchSuccess = createAction('fetch channels success', (channels) => ({ channels }));

const removeChannel = createAction('remove channel', (id) => ({ id }));

const resetChannel = createAction('reset channel', (channel) => ({ channel }));

// update individual fields in the channel model
const updateChannel = createAction('update channel', (channelId, update) => ({ channelId, update }));

const addPublishingManager = createAction('add placement manager', (channelId, publishingManager) => ({
  channelId,
  publishingManager,
}));
const updatePublishingManager = createAction('update placement manager', (channelId, publishingManager) => ({
  channelId,
  publishingManager,
}));
const removePublishingManager = createAction('remove placement manager', (channelId, publishingManagerId) => ({
  channelId,
  publishingManagerId,
}));

const saveChannel = createAction('save channel', (channel) => ({ channel }));
const saveChannelSuccess = createAction('save channel success', (channel) => ({ channel }));
const saveChannelFailure = createApiFailureAction('save channel failure', (error) => ({ error }));

const deleteChannel = createAction('delete channel', (channelId) => ({ channelId }));
const deleteChannelSuccess = createAction('delete channel success', (channelId) => ({ channelId }));
const deleteChannelFailure = createApiFailureAction('delete channel failure', (error) => ({ error }));

const deauthChannel = createAction('deauth channel', (channelId) => ({ channelId }));
const deauthChannelSuccess = createAction('deauth channel success', (channel) => ({ channel }));
const deauthChannelFailure = createApiFailureAction('deauth channel failure', (error) => ({ error }));

export default {
  add,

  fetch,
  fetchFailure,
  fetchSuccess,

  removeChannel,

  resetChannel,

  saveChannel,
  saveChannelFailure,
  saveChannelSuccess,

  updateChannel,

  addPublishingManager,
  updatePublishingManager,
  removePublishingManager,

  deauthChannel,
  deauthChannelSuccess,
  deauthChannelFailure,

  deleteChannel,
  deleteChannelSuccess,
  deleteChannelFailure,
};
